export const SCHEDULE_ZOOM_INTERVALS = [30, 15, 10, 5, 1] as const

export type ScheduleZoomInterval = (typeof SCHEDULE_ZOOM_INTERVALS)[number]

export const DEFAULT_SCHEDULE_ZOOM_INTERVAL: ScheduleZoomInterval = 15

const getIntervalIndex = (current: number): number => {
  const exact = SCHEDULE_ZOOM_INTERVALS.indexOf(current as ScheduleZoomInterval)
  if (exact !== -1) return exact

  let closestIndex = 0
  let closestDistance = Math.abs(SCHEDULE_ZOOM_INTERVALS[0] - current)
  for (let i = 1; i < SCHEDULE_ZOOM_INTERVALS.length; i++) {
    const distance = Math.abs(SCHEDULE_ZOOM_INTERVALS[i] - current)
    if (distance < closestDistance) {
      closestDistance = distance
      closestIndex = i
    }
  }
  return closestIndex
}

export const getNextZoomInInterval = (current: number): ScheduleZoomInterval => {
  const index = getIntervalIndex(current)
  return SCHEDULE_ZOOM_INTERVALS[Math.min(index + 1, SCHEDULE_ZOOM_INTERVALS.length - 1)]
}

export const getNextZoomOutInterval = (current: number): ScheduleZoomInterval => {
  const index = getIntervalIndex(current)
  return SCHEDULE_ZOOM_INTERVALS[Math.max(index - 1, 0)]
}
